import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

function NotFound() {
  const navigate = useNavigate();

  return (
    <section className="flex flex-col items-center justify-center gap-6 w-full h-screen bg-dry text-white">
      {/* LOGO */}
      <motion.img
        src="/saigonstar/logo.webp"
        alt="Saigon Star"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="w-64 md:w-80 object-contain"
      />

      {/* 404 TEXT */}
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-4xl md:text-6xl font-bold text-neonYellow animate-neonFlicker"
      >
        404
      </motion.h1>

      {/* MESSAGE */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="text-gray-400 text-sm md:text-base"
      >
        Page not found
      </motion.p>

      {/* BUTTON */}
      <motion.button
        onClick={() => navigate("/")}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="mt-4 px-6 py-4 bg-neonYellow  rounded-lg font-semibold"
      >
        <span className="text-navy animate-neonFlicker">Back to Home</span>
      </motion.button>

      {/* LOADER (same vibe as Loading.jsx) */}
      <span className="loader block w-3 h-3 rounded-full relative animate-flash" />
    </section>
  );
}

export default NotFound;
